import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'shared-library';

/**
 * Roles that may use the Investigator Portal. The backend (InvestigatorPortalAuthController.CanUsePortal)
 * signs in Administrator and ExternalInvestigator users; Investigator is kept for older accounts.
 * The shared `Roles` enum has no ExternalInvestigator value, so the role names are compared as strings.
 */
const PORTAL_ROLES: readonly string[] = ['Administrator', 'ExternalInvestigator', 'Investigator'];

/**
 * Replaces the shared RoleGuard for the portal. When the role is not allowed it goes to the error page instead of
 * `/case-table`, which the portal redirects back to `/queue`: that cycle re-ran the guard forever and froze the browser.
 */
export const portalAccessGuard: CanActivateFn = () => {
  const role: string | undefined = inject(AuthService).currentUserValue?.role;
  return !!role && PORTAL_ROLES.includes(role) ? true : inject(Router).parseUrl('/error/404');
};
